import { ITest } from "../../interface/IConfig";
import { DATA_INIT } from "../../interface/TStatus";

const tests: ITest[] = [
  {
    request: {
    httpMethod: "POST",
    queryStringParameters: {},
    headers: {
        "Access-Control-Allow-Headers": "Content-Type, X-Amz-Date, Authorization, X-Api-Key, X-Amz-Security-Token, X-Amz-User-Agent",
        "Access-Control-Allow-Origin": "http://localhost:3000",
        "Access-Control-Request-Method": "OPTIONS, POST, GET, PATCH, PUT, DELETE",
        "Content-Type": "application/json; charset=utf8",
        "Accept-Encoding": "gzip, deflate, sdch",
        "Accept-Language": "en-US,en;q=0.8",
        Origin: "http://unit-test.at",
        "x-api-key": "###apiKey###"
      },
      body: {
        username: "max@artcare.at"
      },
        path:  "/idp/reset/password",
    },
    response: {
      statusCode: 200,
      headers: { 
        "content-length": "25",
        "content-type": "application/json"
      },
      body: {
        status: "ok",
        data: {}
      },
    },
    status: DATA_INIT,
  },
];

export default tests;